//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const AvgSalesPriceAffordableWidget = ({ count }: { count: number | string }) => {
  return <StatCard title='Avg. Sales Price - Affordable' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default AvgSalesPriceAffordableWidget;
